<template>
  <div class="card-scroller">

    <div v-if="isLoanApplicationEnabled && offers.length > 0" id="personal-offers">
      <div class="small card-title font-weight-bold mt-3">{{ $t('Offers.title.personal') }}</div>
      <template v-for="(offer, index) in offers">
        <Offer :offer="offer" :key="index"></Offer>
      </template>
    </div>
    <div v-else-if="genericOffers.length > 0">
      <div class="small card-title font-weight-bold mt-3">{{ $t('Offers.title.generic') }}</div>
      <template v-for="(offer, index) in genericOffers">
        <Offer :offer="offer" :key="index"></Offer>
      </template>
    </div>
    <div v-if="promotions.length > 0">
      <div class="small card-title font-weight-bold mt-4">{{ $t('Offers.title.promotions') }}</div>
      <template v-for="(promotion, index) in promotions">
        <Promotion :promotion="promotion" :key="index"></Promotion>
      </template>
    </div>
  </div>
</template>

<script>
import settings from '@shared/settings'
import Offer from '@shared/components/Offer'
import Promotion from '@shared/components/Promotion'

export default {
  name: 'Offers',
  components: { Promotion, Offer },
  props: ['offers', 'genericOffers', 'promotions'],
  computed: {
    isLoanApplicationEnabled() {
      return settings.featureFlags.isLoanApplicationEnabled()
    }
  }
}
</script>
